/**
 * References (Zigzag) block — wires the shared "read full review" modal.
 *
 * The load-more reveal is handled by projectsLoadMore() (the block reuses the
 * data-zigzag-* attributes). Here we only need to ensure the shared modal exists
 * when the references block (with capped quotes) is on the page — on a references
 * page there may be no testimonials slider to set it up.
 */
import { ensureReviewModal } from './review-modal.js';

export function reviewFull() {
  if (!document.querySelector('.review-full [data-review-full]')) return;
  ensureReviewModal();
}
